import { FC } from "react";
import {
    StyledPromotionButton,
    StyledPromotionContent,
    StyledPromotionHeader,
    StyledTypography,
    StyledUpperContainer,
} from "../styledComponents";
import { Truncate } from "@kaltura/mediaspace-shared-ui";
import { HtmlReactParser, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export interface PromotionSection {
    header?: string;
    text?: string;
    buttonText?: string;
    buttonUrl?: string;
}

interface PromotionProps {
    promotion: PromotionSection;
    classes: Partial<Record<"promotion" | "title" | "text" | "button", string>>;
}

const Promotion: FC<PromotionProps> = ({ promotion, classes }) => {
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    const sendButtonAnalytics = useButtonAnalytics();
    const sendAnalytics = (actionName: string) => {
        sendButtonAnalytics(actionName, ButtonClickAnalyticsType.NAVIGATE);
    };

    return (
        <StyledUpperContainer className={classes.promotion}>
            {promotion.header && (
                <StyledPromotionHeader className={classes.title}>
                    <StyledTypography variant={isSmScreen ? "h2" : "h1"} component={"h2"}>
                        <Truncate lines={3} showMore={false}>
                            {promotion.header}
                        </Truncate>
                    </StyledTypography>
                </StyledPromotionHeader>
            )}
            <StyledPromotionContent className={classes.text}>
                {promotion.text && (
                    <StyledTypography variant="body1" component={"p"}>
                        {HtmlReactParser(promotion.text)}
                    </StyledTypography>
                )}
                {promotion.buttonText && (
                    <div>
                        <StyledPromotionButton
                            className={classes.button}
                            onClick={() => {
                                sendAnalytics("Footer - Promotion Link");
                            }}
                            {...(promotion.buttonUrl ? { href: promotion.buttonUrl, target: "_blank" } : {})}
                        >
                            {promotion.buttonText}
                        </StyledPromotionButton>
                    </div>
                )}
            </StyledPromotionContent>
        </StyledUpperContainer>
    );
};

export default Promotion;
